module.exports = __webpack_public_path__ + "img/tablet-elbow-1_75x98.db0dc050.png";